<template>
    <div class="footer">
        <div class="container py-3">
            <div class="row">
                <div class="col-12 col-md-4">
                    <img src="@/assets/NewLogo.png" alt="logo" height="40">
                    <p class="mb-0 font-weight-bold">Advance accounting & co</p>
                    <p>Your trusted partner for reliable, efficient, and personalized tax solutions.</p>
                    <div>
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.3085092253546!2d77.70373857507718!3d13.01601538730345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae110047c6e4ff%3A0xd8812a04fd804d39!2sAdvance%20accounting%20%26%20co!5e0!3m2!1sen!2sin!4v1731737558533!5m2!1sen!2sin"
                            height="200" style="border:0;" allowfullscreen="" loading="lazy"
                            referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>

                </div>
                <div class="col-12 col-md-4">
                    <h3>Our Services</h3>
                    <ul>
                        <li>Insurance Tax</li>
                        <li>Audit & Assurancy</li>
                        <li>Strategic Planning</li>
                        <li>Financial Planning</li>
                        <li>GST</li>
                    </ul>




                </div>
                <div class="col-12 col-md-4">
                    <h3>Contact Us</h3>
                    <p>Address</p>
                    <p>📌 72, 4th main, 7th Cross St, opp. shiva temple, Vinayaka Layout, Battarahalli, Bengaluru,
                        Karnataka 560049</p>
                    <a href="tel:+918494998677">+91 8494998677</a><br>
                    <p><a href="tel:+918197722297">+91 8197722297</a></p>
                    <a href="mailto:aacandco12@gmail.com">Send email(aacandco12@gmail.com)</a>

                </div>
            </div>
        </div>
        <div class="copy-right text-center py-2">
            <p class="mb-0">© 2024 | <strong>Advance accounting & co</strong> | All Rights Reserved.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'footerComponent',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
    background-color: #fcf2e875;
}

.copy-right {
    background-color: coral;
}
</style>